module.exports = __webpack_public_path__ + "img/thumb_03.4f4f96eb.jpg";